// extracted by mini-css-extract-plugin
module.exports = {"CB_container":"BuyItWeDeliverIt-module__CB_container","CB_textContainer":"BuyItWeDeliverIt-module__CB_textContainer"};